import React, { useEffect } from 'react';
import HeroStyle2 from '../../Hero/HeroStyle2';
import Section from '../../Section';
import AboutSectionStyle3 from '../../Section/AboutSection/AboutSectionStyle3';
import WorkingProcess from '../../Section/WorkingProcess';
import BannerSectionStyle2 from '../../Section/BannerSection/BannerSectionStyle2';
import AppointmentSectionStyle2 from '../../Section/AppointmentSection/AppointmentSectionStyle2';
import { pageTitle } from '../../../helpers/PageTitle';
import FunFactSection from '../../Section/FunFactSection';
import funfact from "../../Images/funfact.jpeg";
import labbg4 from "../../Images/bg/labbg4.jpg";
import about from "../../Images/about.png";
import a23 from "../../Images/a23.jpg";
import a2 from "../../Images/a2.png";
import generalvideo from "../../Images/generalvideo.mp4"

const testimonialData = [
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '4.5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '4.5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
];
const workingProcessData = [
    {
        title: 'Appointment Booking & Home Collection',
        subTitle:
            'Track and manage appointment booking and home collection requests easily from the system and app.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '01',
    },
    {
        title: 'Interface Instruments & Software',
        subTitle:
            'Integrate system with Lab Instruments in Uni-direction or Bi-direction and, Third-Party APIs.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_2.svg',
        number: '02',
    },
    {
        title: 'WhatsApp Integration',
        subTitle:
            'Integrate WhatsApp to improve patient experience and enhance patient engagement for your lab.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_3.svg',
        number: '03',
    },
    {
        title: 'Sample Management & Tracking',
        subTitle:
            'Manage sample in a hassle-free way with barcode labels, accession, batch management, standardized vacutainer guide, archival and tracking.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_4.svg',
        number: '04',
    },
    {
        title: 'Automated Communication to Patients',
        subTitle:
            'Automate communication to patients using Promotions, automated SMS campaigns, WhatsApp and email.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_5.svg',
        number: '05',
    },
    {
        title: 'Robust Accounting, Billing and Analytics',
        subTitle:
            'Provides comprehensive billing, accounting and analytics module. Define your chart of accounts and track every machine performance.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_2.svg',
        number: '06',
    },
    {
        title: 'Inventory Management',
        subTitle:
            'Inventory Management to track consumables and reagents.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '07',
    },
    {
        title: 'Asset Management',
        subTitle:
            'Manage your AMC, support and details of every bio-medical equipment you have on your premise.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '08',
    },
];
const blogData = [
    {
        title: 'The Benefits of Mindfulness Meditation for Stress and Anxiety',
        thumbUrl: 'images/home_1/post_1.jpeg',
        date: 'May 1, 2023',
    },
    {
        title: 'Healthy Eating on a Budget: Tips and Strategies',
        thumbUrl: 'images/home_1/post_2.jpeg',
        date: 'May 4, 2023',
    },
    {
        title: 'The Importance of Regular Cancer Screenings and Early Detection',
        thumbUrl: 'images/home_1/post_3.jpeg',
        date: 'May 1, 2023',
    },
];
const faqData = [
    {
        title: 'What services does ProHealth offer?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'How do I schedule an appointment with ProHealth?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'Do you accept insurance?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'What should I bring to my appointment?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'How do I request a prescription refill?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
];
const brandData = [
    {
        imgUrl: '/images/brand_1.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_2.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_3.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_4.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_5.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_6.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_7.png',
        imgAlt: 'Brand',
    },
];
const funFactData = [
    { number: '15+', title: 'Years of experience' },
    { number: '1.6 Cr', title: 'Patient Registration' },
    { number: '700000+', title: 'Transactions per day.' },
    { number: '300+', title: 'Hospitals,Diagnostic Centers and Pharmacies Customers' },
    { number: '5+', title: 'Countries Customers' },
];

export default function Laboratory() {
    pageTitle('Home V2');
    
    // Preload the background image for faster loading
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = labbg4;
        link.fetchPriority = 'high';
        document.head.appendChild(link);
        
        // Also preload the image in browser cache
        const img = new Image();
        img.src = labbg4;
        
        return () => {
            document.head.removeChild(link);
        };
    }, []);
    
    return (
        <>
            <HeroStyle2
                title="Laboratory Solutions"
                subTitle="Medna Data Systems LIS provides comprehensive infrastructure in terms of Integration with
         bio-medical equipment, patient engagement and reporting of Labs reports to reference doctor,
          patient and relevant department which will assist them in taking decision. Medna Data Systems is 
          integrated product includes LIS, Hospital information system, RCM and accounting, 
          product has demonstrated how a paperless implementation could be achieved with hospital 
          linking to various labs department and also track external lab tests from independent Labs."
                bgUrl={labbg4}            
                imgUrl={process.env.PUBLIC_URL +"/images/home_2/patents.png"}
            // btnText="Doc Choice"
            // btnUrl="/"
            />
            <Section topMd={175} topLg={125} topXl={85}>
                <FunFactSection
                    bgUrl={funfact}
                    data={funFactData}
                />
            </Section>

            {/* <Section bottomMd={125} bottomLg={125} bottomXl={85}>
        <DepartmentSectionStyle4
          sectionTitle="For Your Health"
          sectionTitleUp="OUR DEPARTMENTS"
          data={departmentData}
        />
      </Section> */}
            {/* <Section
        className="cs_bg_filed"
        style={{ backgroundImage: `url(/images/home_2/testimonial_bg.svg)` }}
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSectionStyle2
          sectionTitle="What Are the Benefits of <br /> Electronic Health Records?"
          sectionTitleUp="BENEFITS"
          data={testimonialData}
        />
      </Section> */}
            <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <WorkingProcess
                    sectionTitle="What Are the Benefits of Choosing Laboratory Solutions?"
                    sectionTitleUp=""
                    sectionTitleDown=""
                    data={workingProcessData}
                />
            </Section>
            <Section>
                <BannerSectionStyle2
                    bgUrl={a23}
                    title="Don’t Let Your Hospital <br />Take a Backseat!"
                    subTitle="Schedule an demo with one of our experienced <br />professionals today!"
                />
            </Section>
            {/* <Section topMd={190} topLg={145} topXl={105}>
        <BlogSectionStyle3
          sectionTitle="Latest Update"
          sectionTitleUp="BLOG POSTS"
          sectionTitleDown=""
          sectionSubTitle=""
          data={blogData}
        />
      </Section> */}
            <Section bottomMd={190} bottomLg={145} bottomXl={105}>
                <AboutSectionStyle3
                    titleUp="Decades of expertise and market leadership. A distinguished history of 
          innovative Healthcare Solutions."
                    title="Meet The Minds Behind Medna Data Systems"
                    subTitle="Building compliant, scalable healthcare technology for the UAE.
Medna Data Systems is a healthcare technology company focused on delivering a robust, 
regulatory-ready Healthcare ERP and HMIS platform for clinics and hospitals operating in the UAE.
We bring together deep technical expertise, healthcare domain knowledge, and real-world implementation
 experience to solve one core problem: making healthcare operations simpler, compliant, and efficient
  without compromising patient data or clinical workflows."
                    imgUrl={about}
                />
            </Section>
            {/* Start FAQ Section */}
            {/* <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <FaqSectionStyle2
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section> */}
            {/* End FAQ Section */}
            <Section>
                <AppointmentSectionStyle2
                    bgUrl={process.env.PUBLIC_URL +"/images/home_2/appointment_bg.svg"}
                    imgUrl={a2}
                    sectionTitle="Appointment"
                    sectionTitleUp="BOOK AN"
                />
            </Section>
            {/* <Section
                topMd={200}
                topLg={150}
                topXl={110}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <BrandsSectionStyle2 data={brandData} />
            </Section> */}
        </>
    );
}
